import { useTranslation } from "react-i18next";
import GenericCard from "widgets/cards/generic";
import BuildForm from "widgets/forms/reports/build";

interface MyDocumentProps {
  data?: any;
  step: number;
  setStep: (step: number) => void;
  onSubmit: (data: any) => void;
}

const Configuration: React.FC<MyDocumentProps> = ({
  onSubmit,
  data,
  step,
  setStep,
}) => {
  const { t } = useTranslation();

  return (
    <GenericCard
      title={t("reports.configuration.step.title")}
      description={t("reports.configuration.step.description")}
      bgColor="400"
      textColor="white"
      extra="h-full"
    >
      <BuildForm
        submit={(data) => {
          onSubmit(data);
          setStep(0);
        }}
        disabled={step === 3}
        onTouched={() => {
          setStep(0);
        }}
      />
    </GenericCard>
  );
};

export default Configuration;
